import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiGateway } from "api/api-gateway";
import { AuthService } from "app/services/auth.service";

@Injectable()
export class CheckinService {
    constructor(private apiGateway: ApiGateway, private authService: AuthService) {}

    /*getInsuranceList(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.apiGateway
                .get("datasnap/rest/TEntityController/convenios")
                .subscribe((res: HttpResponse<any>) => {
                    if (res.body) {
                        resolve(res.body);
                    } else {
                        resolve(res);
                    }
                }, reject);
        });
    }*/

    getInsuranceList(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.apiGateway
                .get("insurance/app/list")
                .subscribe((res: HttpResponse<any>) => {
                    if (res.body) {
                        resolve(res.body);
                    } else {
                        resolve(res);
                    }
                }, reject);
        });
    }

    getProfessionalList(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.apiGateway
                .get("datasnap/rest/TEntityController/profissionais")
                .subscribe((res: HttpResponse<any>) => {
                    if (res.body) {
                        resolve(res.body);
                    } else {
                        resolve(res);
                    }
                }, reject);
        });
    }

    getScheduleList(patientId, type: string, pageOptions): Promise<any> {
        let urlPath = `scheduling/app/${patientId}/${type}`;

        return new Promise((resolve, reject) => {
            this.apiGateway.post(urlPath, pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err) => {
                    reject(err);
                },
            });
        });
    }

    getSpecialityList(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.apiGateway
                .get("datasnap/rest/TEntityController/especialidades")
                .subscribe((res: HttpResponse<any>) => {
                    if (res.body) {
                        resolve(res.body);
                    } else {
                        resolve(res);
                    }
                }, reject);
        });
    }

    /*getCheckinList(patientId): Promise<any> {
        return new Promise((resolve, reject) => {
            this.apiGateway
                .get(
                    "datasnap/rest/TCalendarController/consultaAgendamentoPaciente/" +
                        patientId
                )
                .subscribe((res: HttpResponse<any>) => {
                    if (res.body) {
                        resolve(res.body);
                    } else {
                        resolve(res);
                    }
                }, reject);
        });
    }*/

    getCheckinList(patientId): Promise<any> {
        return new Promise((resolve, reject) => {
            this.apiGateway
                .get("scheduling/app/" + patientId)
                .subscribe((res: HttpResponse<any>) => {
                    if (res.body) {
                        resolve(res.body);
                    } else {
                        resolve(res);
                    }
                }, reject);
        });
    }

    consultaAgendamentoPorUnidadeEspecialidade(idUnidade, idEspecialidade) {
        return new Promise((resolve, reject) => {
            this.apiGateway
                .get(
                    `datasnap/rest/TCalendarController/consultaAgendamentoUnidadeEspecialidade/${idUnidade}/${idEspecialidade}`
                )
                .subscribe((res: HttpResponse<any>) => {
                    if (res.body) {
                        resolve(res.body);
                    } else {
                        resolve(res);
                    }
                }, reject);
        });
    }

    saveSchedule(schedule) {
        return new Promise((resolve, reject) => {
            this.apiGateway
                .post(
                    `datasnap/rest/TCalendarController/agendamento/`,
                    schedule
                )
                .subscribe((res: HttpResponse<any>) => {
                    if (res.body) {
                        resolve(res.body);
                    } else {
                        resolve(res);
                    }
                }, reject);
        });
    }

    saveCheckin(scheduleId) {
        return new Promise((resolve, reject) => {
            this.apiGateway
                .get(
                    `datasnap/rest/TCalendarController/agendamento/${scheduleId}/P/PRESENTE`
                )
                .subscribe((res: HttpResponse<any>) => {
                    if (res.body) {
                        resolve(res.body);
                    } else {
                        resolve(res);
                    }
                }, reject);
        });
    }

    checkin(scheduleId): Promise<{ data: any }> {
        return this.authService.runWithAdminToken(
            () =>
                new Promise((resolve, reject) => {
                    this.apiGateway
                        .post(`scheduling/${scheduleId}/P/PRESENTE`)
                        .subscribe((res) => {
                            if (res.body) {
                                resolve(res.body);
                            } else {
                                resolve(res);
                            }
                        }, reject);
                })
        );
    }
}
